<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <size-information-create-or-update v-model="sizeInformation" :errors="errors"></size-information-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :buttons="buttons"
                    :fields="fields"
                    name="size-information"
                    pagination="server"
                    search
                    :items-provider="provider"
                    :add-callback="createNew"></v-table>

    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SizeInformationCreateOrUpdate from './components/SizeInformationCreateOrUpdate.vue';
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
export default {
    components:{
        BCard,
        SizeInformationCreateOrUpdate
    },
    data () {
        return {
            fields:[
                {name:"Beden",key:"Name", thClass:"w-100",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            loading:false,
            errors:{},
            sizeInformation:{
                Id:null,
                Name:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.sizeInformation.Id = null
            this.sizeInformation.Name = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HumanResourcesParameterApi.SizeInformation.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.sizeInformation.Id = item.Id
            this.sizeInformation.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParameterApi.SizeInformation.CreateOrUpdate(this.editing,this.sizeInformation).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} beden bilgisini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParameterApi.SizeInformation.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        
    }

}
</script>

<style>

</style>